exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".condition-details-renderer {\n  margin-top: 16px;\n}\n.condition-details-renderer a {\n  text-decoration: underline;\n}\n", ""]);

// exports
